// Tiny client for the Lu.ft Online (Summer Sessions) members gate.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const STORAGE_KEY = "luft-members-token";

export function getStoredToken() {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(STORAGE_KEY);
}

export function storeToken(token) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, token);
}

export function clearToken() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(STORAGE_KEY);
}

export async function requestAccess(password) {
  const { data } = await axios.post(`${API}/online/access`, { password });
  storeToken(data.token);
  return data;
}

export async function verifyAccess() {
  const token = getStoredToken();
  if (!token) return null;
  try {
    const { data } = await axios.get(`${API}/online/verify`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch {
    clearToken();
    return null;
  }
}
